var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3AAE37",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M16.8 9.45C16.8 6.446 13.75 4 10 4S3.2 6.445 3.2 9.45c0 2.695 2.42 4.952 5.687 5.379.221.047.523.144.599.33.069.17.045.437.022.608l-.097.575c-.03.17-.137.664.589.362.726-.302 3.916-2.278 5.343-3.9.985-1.067 1.457-2.15 1.457-3.353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3AAE37",
    d: "M8.637 8c.07 0 .126.059.126.131v2.938c0 .072-.057.13-.126.13h-.455a.129.129 0 0 1-.126-.13V8.131c0-.072.057-.13.126-.13h.455zm3.128 0c.07 0 .126.059.126.131v2.938c0 .072-.057.13-.126.13h-.455a.12.12 0 0 1-.032-.003h-.002l-.009-.004-.003-.001-.006-.003-.006-.003-.004-.002a.066.066 0 0 1-.01-.006.131.131 0 0 1-.031-.032l-1.295-1.82v1.744c0 .072-.057.13-.127.13h-.454a.129.129 0 0 1-.126-.13V8.131c0-.072.056-.13.126-.13h.472l.005.001.008.002.004.001.007.003.004.001.008.003.004.002.006.004.004.003.007.004.003.003a.071.071 0 0 1 .007.006l.002.002.008.008v.001l.01.013 1.294 1.818V8.131c0-.072.056-.13.126-.13h.455zM7.54 10.464c.07 0 .126.06.126.132v.473a.129.129 0 0 1-.126.131H5.726a.124.124 0 0 1-.087-.037l-.002-.001-.002-.003a.133.133 0 0 1-.035-.09V8.13c0-.072.056-.131.126-.131h.455c.07 0 .126.059.126.131v2.333H7.54zm6.733-1.728h-1.235v.496h1.235c.07 0 .126.059.126.132v.473a.129.129 0 0 1-.126.13h-1.235v.497h1.235c.07 0 .126.06.126.132v.473a.129.129 0 0 1-.126.131h-1.815a.123.123 0 0 1-.09-.038l-.001-.002a.133.133 0 0 1-.035-.091V8.13a.133.133 0 0 1 .037-.092v-.002A.123.123 0 0 1 12.46 8h1.815c.07 0 .126.059.126.131v.473a.129.129 0 0 1-.126.132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLine);
export default __webpack_public_path__ + "static/media/ic-line.610edb18dd35ae6201f5cdd197999d8d.svg";
export { ForwardRef as ReactComponent };